/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
// import { AnimationOnScroll } from 'react-animation-on-scroll';
// import 'animate.css/animate.min.css';

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },
    background: "#fafafa",
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    // padding: "0rem 8rem 0rem 8rem",
    padding: "0rem 8rem 2rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
      padding: "0rem 0rem 2rem 0rem",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "2rem 0rem 2rem 0rem",
    gap: "2rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "60%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  heading: {
    width: "100%",
    margin: "0rem 0rem 0.5rem 0rem",
    fontWeight: 400,
    color: "#0DB14B",
    // background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    fontSize: "2.5rem",
    lineHeight: "3rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.75rem",
      lineHeight: "2.125rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.75rem",
      lineHeight: "2.125rem",
    },
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.625rem",
    },
  },
  illustrationSizer: {
    /* XXS breakpoint */
    objectFit: "contain",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "280px",
      width: "280px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "210px",
      width: "210px",
    },
    [theme.breakpoints.only("sm")]: {
      height: "210px",
      width: "210px",
    },
    [theme.breakpoints.only("md")]: {
      height: "300px",
      width: "300px",
    },
    [theme.breakpoints.only("lg")]: {
      height: "320px",
      width: "320px",
    },
    [theme.breakpoints.only("xl")]: {
      height: "300px",
      width: "300px",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      height: "300px",
      width: "300px",
    },
  },
}));

const SectionTwo = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.text}>
            <Typography
              variant="h1"
              component="h1"
              className={classes.heading}
            >
              Vaastu
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.subHeading}
            >
              The five elements of nature (earth, fire, wind, water and space) have a direct impact on energizing the
              place we live and facilitate activation of our chakras. The principles of Vaastu try to place these five
              elements such that there is a positive energy flow in the living space.
            </Typography>
          </div>
          {/* <AnimationOnScroll animateIn="animate__fadeIn" duration={2}> */}
          <div className={classes.animation}>
            <img
              src="/images/icons/heavie/aboutus/vastu_purusha.svg"
              alt={AppConfig.imageAltText}
              width={512}
              height={512}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.illustrationSizer}
            />
          </div>
          {/* </AnimationOnScroll> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionTwo;

// /* Common Imports */
// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

// /* Component Imports */
// import { Typography } from "@material-ui/core";

// /* Data Imports */
// import AppConfig from "../../../AppConfig";

// const useStyles = makeStyles((theme) => ({
//   megaContainer: {
//     /* XXS breakpoint */
//     [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
//       padding: "0rem 0.5rem 1rem 0.5rem",
//     },
//     [theme.breakpoints.only("xs")]: {
//       padding: "0rem 1.5rem 1rem 1.5rem",
//     },
//     [theme.breakpoints.only("sm")]: {
//       padding: "0rem 3rem 1rem 3rem",
//     },
//     [theme.breakpoints.only("md")]: {
//       padding: "0rem 4rem 1rem 4rem",
//     },
//     [theme.breakpoints.only("lg")]: {
//       padding: "0rem 4rem 1rem 4rem",
//     },
//     /* XLG breakpoint */
//     [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
//       padding: "0rem 5rem 1rem 5rem",
//     },
//     /* Full HD breakpoint */
//     [theme.breakpoints.up("xl")]: {
//       padding: "0rem 23rem 1rem 23rem",
//     },
//     /* XXL breakpoint */
//     [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
//       padding: "0rem 36rem 1rem 36rem",
//     },
//     /* XXXL breakpoint */
//     [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
//       padding: "0rem 72rem 1rem 72rem",
//     },
//     background: "#fafafa",
//     margin: "0rem 0rem 6rem 0rem",
//     [theme.breakpoints.down("xs")]: {
//       margin: "0rem 0rem 3rem 0rem",
//     },
//   },
//   sectionContainer: {
//     display: "flex",
//     flexDirection: "row",
//     [theme.breakpoints.down("xs")]: {
//       flexDirection: "column",
//       justifyContent: "center",
//     },
//     justifyContent: "space-between",
//     alignItems: "center",
//     width: "100%",
//     padding: "2rem 0rem 2rem 0rem",
//     gap: "2rem",
//   },
//   text: {
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "60%",
//     [theme.breakpoints.down("sm")]: {
//       width: "100%",
//     },
//   },
//   heading: {
//     width: "100%",
//     margin: "0rem 0rem 0.5rem 0rem",
//     color: "#4A225B",
//     fontWeight: 400,
//     background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
//     "-webkit-background-clip": "text",
//     "-webkit-text-fillColor": "transparent",
//     fontSize: "2.5rem",
//     lineHeight: "3rem",
//     [theme.breakpoints.down("sm")]: {
//       fontSize: "1.75rem",
//       lineHeight: "2.125rem",
//     },
//     [theme.breakpoints.down("xs")]: {
//       fontSize: "1.75rem",
//       lineHeight: "2.125rem",
//     },
//   },
//   subHeading: {
//     margin: "0.5rem 0rem 0.5rem 0rem",
//     width: "100%",
//     color: "#202020",
//     fontWeight: 400,
//     fontSize: "1.125rem",
//     lineHeight: "2rem",
//     [theme.breakpoints.down("sm")]: {
//       fontSize: "1rem",
//       lineHeight: "1.625rem",
//     },
//   },
//   illustrationSizer: {
//     /* XXS breakpoint */
//     objectFit: 'contain',
//     [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
//       height: "280px",
//       width: "280px",
//     },
//     [theme.breakpoints.only("xs")]: {
//       height: "320px",
//       width: "320px",
//     },
//     [theme.breakpoints.only("sm")]: {
//       height: "352px",
//       width: "352px",
//     },
//     [theme.breakpoints.only("md")]: {
//       height: "300px",
//       width: "300px",
//     },
//     [theme.breakpoints.only("lg")]: {
//       height: "320px",
//       width: "320px",
//     },
//     [theme.breakpoints.only("xl")]: {
//       height: "300px",
//       width: "300px",
//     },
//     /* XXL breakpoint */
//     [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
//       height: "300px",
//       width: "300px",
//     },
//   },
// }));

// const SectionTwo = () => {
//   const classes = useStyles();
//   return (
//     <React.Fragment>
//       <div className={classes.megaContainer}>
//         <div className={classes.sectionContainer}>
//           <div className={classes.text}>
//             <Typography variant="h1" component="h1" className={classes.heading}>
//               Vaastu
//             </Typography>
//             <Typography
//               variant="body2"
//               component="span"
//               className={classes.subHeading}
//             >
//               The five elements of nature (earth, fire, wind, water and space)
//               have a direct impact on energizing the place we live and
//               facilitate activation of our chakras. The principles of Vaastu try
//               to place these five elements such that there is a positive energy
//               flow in the living space.
//             </Typography>
//           </div>
//           <div className={classes.animation}>
//             <img
//               src="/images/icons/heavie/aboutus/vastu_purusha.svg"
//               alt={AppConfig.imageAltText}
//               width={512}
//               height={512}
//               loading="lazy"
//               referrerPolicy="no-referrer"
//
//               className={classes.illustrationSizer}
//             />
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default SectionTwo;
